<template>
	<v-menu
		:ref="menuLocal"
		v-model="menuLocal"
		:close-on-content-click="false"
		transition="scale-transition"
		offset-y
		max-width="290px"
		min-width="290px"
		@change="emitMenu"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-model="dateLocal"
				:label="label"
				readonly
				v-bind="attrs"
				v-on="on"
				@change="emitDate"
			></v-text-field>

		</template>
		<v-date-picker
			v-model="dateLocal"
			no-title
			:scrollable="scrollable"
			:first-day-of-week="1"
			:allowed-dates="allowedDates"
			@change="emitDate"
		/>
	</v-menu>
</template>

<script>
export default {
	name: 'DatePicker',
	props: {
		menu: {
			required: true,
			type: Boolean,
			default: false,
		},
		date: {
			required: true,
		},
		rules: {
			type: Array,
		},
		label: {
			type: String,
		},
		scrollable: {
			type: Boolean,
			default: true,
		},
		itemIndex: {
			required: false,
		},
	},
	data() {
		return {
			dateLocal: this.date,
			menuLocal: this.menu,
		}
	},
	methods: {
		allowedDates(val) {
			const d1 = new Date(val)
			const d2 = new Date()
			return d1 < d2
		},
		emitDate() {
			this.$emit('update:date', this.dateLocal)
			this.$emit('changeEmit', this.dateLocal, this.itemIndex)
		},
		emitMenu() {
			this.$emit('update:menu', this.menuLocal)
		},
	},
}
</script>

<style>

</style>
